import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { EventLogsComponent } from '../../device/device-management/event-logs/event-logs.component';

@Component({
  selector: 'app-scheduled-event-logs-details',
  standalone: true,
  imports: [TranslateModule, AngularSvgIconModule, RouterLink, EventLogsComponent],
  templateUrl: './scheduled-event-logs-details.component.html',
  styleUrl: './scheduled-event-logs-details.component.scss',
})
export class ScheduledEventLogsDetailsComponent {
  // The event list loads once on init, so the meter is taken from the URL before it is created.
  readonly meterId: string;

  constructor(route: ActivatedRoute) {
    this.meterId = route.snapshot.queryParamMap.get('meterId') ?? '';
  }
}
